import { css } from 'styled-components';
export default {
    navHeight: 107,
    navHeightTablet: 80,
    navHeightMobile: 59,
};
export const ButtonReset = css `
  border: none;
  outline: none;
  padding: 0px;
  background: none;
  border-radius: 0px;
`;
export const underline = css `
  text-decoration: underline;
  text-decoration-color: var(--accentColor);
  text-decoration-thickness: 2px;
  text-underline-position: under;
`;
export const underlineThick = css `
  text-decoration: underline;
  text-decoration-color: var(--accentColor);
  text-decoration-thickness: 4px;
  text-underline-position: under;
`;
export const InfinityTrackingCssClass = 'InfinityNumber';
